export default __webpack_public_path__ + "static/media/checkSign.2c8e1540.png";